<template>
  <v-content>
    <v-container>
      <v-row justify="center">
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        ></v-progress-circular>
      </v-row>
      <template v-if="!loading">
        <v-card
          class="elevation-1 mx-auto"
          v-for="group in groups"
          :key="group.uuid"
          max-width="750"
        >
          <v-card-actions
            v-if="group.is_supergroup && !group.isVirtual && !group.isMocked"
            class="my-2"
          >
            <v-spacer></v-spacer>

            <v-btn
              class="mr-4 mt-2"
              color="primary"
              dark
              @click="addGroup(group)"
              >{{ $t("users.brands.addBrand") }}
            </v-btn>
          </v-card-actions>
          <v-divider
            v-if="group.is_supergroup && !group.isVirtual && !group.isMocked"
          ></v-divider>
          <v-row
            v-for="subgroup in group.subgroups"
            :key="subgroup.uuid"
            no-gutters
          >
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="elevation-0 my-2">
                <v-card-actions>
                  <div class="ml-10">
                    <v-icon class="mr-2 mb-1">mdi-account-group</v-icon
                    ><span class="subtitle-1 grey--text text--darken-1">
                      {{ subgroup.name }}
                    </span>
                  </div>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="setAddUserRangeFormStatus(subgroup, 'range')"
                    v-if="
                      subgroup.details && canUserAddEditGroupDetails(subgroup)
                    "
                  >
                    <v-icon class="mr-2">mdi-plus-circle</v-icon
                    >{{ $t("users.brands.addRange") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="setAddUserRangeFormStatus(subgroup, 'invite')"
                    v-if="
                      subgroup.details && canUserAddEditGroupDetails(subgroup)
                    "
                    ><v-icon class="mr-2">mdi-account-plus</v-icon
                    >{{ $t("users.brands.addUser") }}
                  </v-btn>
                  <v-btn
                    @click="editGroup(subgroup, 'details')"
                    v-if="
                      canAccessGroup(subgroup) &&
                      subgroup.details &&
                      canUserAddEditGroupDetails(subgroup)
                    "
                    icon
                    color="primary"
                    ><v-icon>mdi-pencil</v-icon></v-btn
                  >
                  <v-btn
                    class="mr-4"
                    @click="showGroupDetails(subgroup)"
                    icon
                    color="primary"
                    v-if="canUserSeeGroupDetails(subgroup)"
                    ><v-icon v-if="!subgroup.details">mdi-chevron-down </v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card flat class="mt-0 pt-0 mb-3" v-if="subgroup.details">
                <div v-if="subgroup.subgroups.length !== 0 && !group.isVirtual">
                  <group-details
                    :group-uuid="subgroup.uuid"
                    :access="
                      canAccessGroup(subgroup) &&
                      canUserAddEditGroupDetails(subgroup)
                    "
                    :key="subgroup.uuid"
                    :show-add-range="true"
                    :show-add-user-range-form="subgroup.showAddUserRangeForm"
                    :loading.sync="loadingSubgroup"
                    @reload="handleReloadGroups"
                  ></group-details>
                  <div v-if="!loadingSubgroup">
                    <v-card-text class="ml-8">
                      {{ $t("users.brands.ranges") }}
                    </v-card-text>
                    <sub-brand-details
                      :subgroups="subgroup.subgroups"
                      :key="subgroup.uuid"
                    ></sub-brand-details>
                  </div>
                </div>
                <div v-else>
                  <group-details
                    :group-uuid="subgroup.uuid"
                    :access="
                      canAccessGroup(subgroup) &&
                      canUserAddEditGroupDetails(subgroup)
                    "
                    :key="subgroup.uui"
                    :show-add-range="true"
                    :show-add-user-range-form="subgroup.showAddUserRangeForm"
                    @reload="handleReloadGroups"
                  ></group-details>
                  <!-- <div v-if="subgroup.subgroups.length === 0">
                    <v-card-text class="ml-8"
                      >Click on "add user" or "add range" to
                      proceed</v-card-text
                    >
                  </div> -->
                </div>
              </v-card>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import GroupDetails from "@/components/miscellaneous/GroupDetails";
import SubBrandDetails from "@/components/miscellaneous/SubBrandDetails.vue";
import restrictions from "@/utils/restrictions.js";

export default {
  components: {
    GroupDetails,
    SubBrandDetails,
  },
  data: () => ({
    groups: [],
    subgroups: [],
    loading: true,
    loadingSubgroup: false,
    deleteDialog: false,
    roleUuid: null,
    groupUuid: null,
    roleName: null,
    update: 0,
    // showAddUserRangeForm: "",
  }),
  created() {
    this.loadGroupList();
  },
  methods: {
    canUserSeeGroupDetails(subgroup) {
      return restrictions.canUserSeeGroupDetails(subgroup.my_permissions);
    },
    canUserAddEditGroupDetails(subgroup) {
      return restrictions.canUserAddEditGroupDetails(subgroup.my_permissions);
    },
    setAddUserRangeFormStatus(subgroup, event) {
      subgroup.showAddUserRangeForm =
        subgroup.showAddUserRangeForm === event ? "" : event;
      this.$forceUpdate();
    },
    showGroupDetails(subgroup) {
      if (subgroup.details) {
        subgroup.details = false;
        this.$forceUpdate();
        return;
      }

      subgroup.details = true;
      this.$forceUpdate();
    },
    canAccessGroup(group) {
      return group.my_permissions.groups_permission !== "NONE";
    },
    loadGroupList() {
      return api.getGroupList().then((resp) => {
        this.groups = this.processGroups(resp.data.results);
        this.loading = false;
      });
    },
    handleReloadGroups(event) {
      const index = this.groups[0].subgroups.findIndex(
        (subgroup) => subgroup.uuid === event.uuid
      );

      this.$set(
        this.groups[0].subgroups[index].subgroups,
        this.groups[0].subgroups[index].subgroups.length,
        event.data
      );
    },
    processGroups(groups) {
      let supergroups = groups.filter((x) => x.is_supergroup);
      let subgroups = groups.filter((x) => !x.is_supergroup);

      if (subgroups.length && !supergroups.length) {
        subgroups = subgroups.map((item) => {
          const ranges = item.subgroups.map((el) => {
            return { ...el, isVirtual: false };
          });

          return { ...item, isVirtual: false, subgroups: ranges };
        });

        supergroups.push(
          Object.assign(
            {},
            {
              ...subgroups[0],
              subgroups: subgroups,
              is_supergroup: true,
              isMocked: true,
            }
          )
        );
      } else if (subgroups.length) {
        supergroups.push(
          Object.assign(subgroups[0], {
            isVirtual: true,
            subgroups: subgroups,
            isMocked: false,
          })
        );
      }

      return supergroups.map((group) => {
        return {
          ...group,
          details: false,
          loading: false,
        };
      });
    },

    addGroup(group) {
      this.$router.push({
        name: "subgroupBrand",
        params: { id: group.uuid },
      });
    },

    editGroup(group, tab) {
      this.$router.push({
        name: "groups",
        params: { brandId: group.uuid, tab: tab },
      });
    },
  },
};
</script>
